import { archetypeWpmHint, GOAL_ARCHETYPES } from '../data/goalArchetypes';
import type { GoalArchetypeId } from '../types';

interface GoalArchetypePickerProps {
  suggestedId?: GoalArchetypeId;
  selectedId: GoalArchetypeId | null;
  onSelect: (id: GoalArchetypeId) => void;
}

export default function GoalArchetypePicker({
  suggestedId,
  selectedId,
  onSelect,
}: GoalArchetypePickerProps) {
  return (
    <div className="grid gap-2 sm:grid-cols-1">
      {GOAL_ARCHETYPES.map((a) => {
        const active = selectedId === a.id;
        const suggested = suggestedId === a.id;
        return (
          <button
            key={a.id}
            type="button"
            onClick={() => onSelect(a.id)}
            className={`rounded-xl px-4 py-3 text-left ring-1 transition ${
              active
                ? 'bg-indigo-50 ring-indigo-300 dark:bg-indigo-500/15 dark:ring-indigo-500/50'
                : 'bg-white ring-zinc-200 hover:bg-zinc-50 dark:bg-zinc-900/60 dark:ring-white/10 dark:hover:bg-zinc-800/60'
            }`}
          >
            <div className="flex items-start justify-between gap-2">
              <span className="font-semibold text-strong">{a.title}</span>
              <span className="shrink-0 text-right text-xs text-faint">
                {archetypeWpmHint(a.id)}
              </span>
            </div>
            <p className="mt-1 text-xs text-muted">{a.tagline}</p>
            {suggested && !active && (
              <p className="mt-1 text-[10px] font-medium text-amber-800/90 dark:text-amber-200/90">
                Forslag ud fra dit udgangspunkt
              </p>
            )}
          </button>
        );
      })}
    </div>
  );
}
